import axios from 'axios'
import { SiteReport, CreateSiteReport, UpdateSiteReport } from './interfaces'

const apiURL = process.env.REACT_APP_API_URL

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken')
  if (!token) throw new Error('Authorization token not found')
  return {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token,
  }
}

// GET: /SiteReport/job/{jobId}
export const getSiteReportsByJob = async (jobId: number): Promise<SiteReport[]> => {
  const response = await axios({
    url: `https://${apiURL}/SiteReport/job/${jobId}`,
    method: 'get',
    headers: getAuthHeaders(),
  })
  return response.data
}

// GET: /SiteReport/{id}
export const getSiteReport = async (id: number): Promise<SiteReport> => {
  const response = await axios({
    url: `https://${apiURL}/SiteReport/${id}`,
    method: 'get',
    headers: getAuthHeaders(),
  })
  return response.data
}

// POST: /SiteReport
export const createSiteReport = async (dto: CreateSiteReport): Promise<SiteReport> => {
  const response = await axios({
    url: `https://${apiURL}/SiteReport`,
    method: 'post',
    data: dto,
    headers: getAuthHeaders(),
  })
  return response.data
}

// PUT: /SiteReport/{id}
export const updateSiteReport = async (id: number, dto: UpdateSiteReport): Promise<SiteReport> => {
  const response = await axios({
    url: `https://${apiURL}/SiteReport/${id}`,
    method: 'put',
    data: dto,
    headers: getAuthHeaders(),
  })
  return response.data
}

// DELETE: /SiteReport/{id}
export const deleteSiteReport = async (id: number): Promise<void> => {
  const token = localStorage.getItem('authToken')
  if (!token) throw new Error('Authorization token not found')
  await axios({
    url: `https://${apiURL}/SiteReport/${id}`,
    method: 'delete',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
}
